import { NoticeProps } from '@applyboard/crystal-ui'
import { DecisionDocumentTags, DocumentTags } from '../../../../../utils/enums'
import { DecisionResponseType } from '@applyboard/school-applications-types-lib/dist/src/backend/applications-api/resources/applications/student-decisions'

export function getHelperText(
  documentTag: DecisionDocumentTags,
  status: DecisionResponseType | undefined,
  hasCondition: boolean,
  activeRecord: boolean,
  isRevoked?: boolean,
):
  | {
      label: NoticeProps['children']
      intent: NoticeProps['intent']
    }
  | undefined {
  switch (true) {
    case isRevoked:
      return {
        label: 'This offer was revoked and can no longer be verified by third parties.',
        intent: 'secondary',
      }
    case documentTag === DocumentTags.DECLINED_LETTER:
      return {
        label:
          'We regret to inform you that, after careful consideration of your application, the school has decided to decline your offer.',
        intent: 'negative',
      }
    case documentTag === DocumentTags.WAITLIST_LETTER:
      return hasCondition
        ? {
            label: 'Please download the attached letter, review the offer conditions, and respond.',
            intent: 'warning',
          }
        : undefined
    case documentTag === DocumentTags.PRE_OFFER_LETTER:
      if (status === DecisionResponseType.REJECTED && activeRecord) {
        return {
          label: 'A decision has been made by you to reject the pre-offer letter.',
          intent: 'negative',
        }
      }
      if ((!status || status === DecisionResponseType.PENDING) && hasCondition) {
        return {
          label: 'Please download the attached letter, review the offer conditions, and respond.',
          intent: 'positive',
        }
      }
      return undefined
    case documentTag === DocumentTags.FINAL_OFFER_LETTER:
      return activeRecord && status !== DecisionResponseType.REJECTED
        ? {
            label: 'Congratulations! You have received a final offer.',
            intent: 'positive',
          }
        : undefined

    default:
      return hasCondition
        ? {
            label: 'Please download the attached letter, review the offer conditions, and respond.',
            intent: 'positive',
          }
        : undefined
  }
}
